import createIcon from '../../createIcon';

/**
 * @component @name Celebration
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMS4yMzA0NyAyMi4yNzA1TDE1LjIzMDUgMTcuMjcwNUw2LjIzMDQ3IDguMjcwNDdMMS4yMzA0NyAyMi4yNzA1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEzLjc2MDUgMTIuODAwNUwxOS4zNTA1IDcuMjEwNDdDMTkuODQwNSA2LjcyMDQ3IDIwLjYzMDUgNi43MjA0NyAyMS4xMjA1IDcuMjEwNDdMMjEuNzEwNSA3LjgwMDQ3TDIyLjc3MDUgNi43NDA0N0wyMi4xODA1IDYuMTUwNDdDMjEuMTEwNSA1LjA4MDQ3IDE5LjM2MDUgNS4wODA0NyAxOC4yOTA1IDYuMTUwNDdMMTIuNzAwNSAxMS43NDA1TDEzLjc2MDUgMTIuODAwNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik05LjI5MDQ3IDcuMTUwNDdMOC43MDA0NyA3Ljc0MDQ3TDkuNzYwNDcgOC44MDA0N0wxMC4zNTA1IDguMjEwNDdDMTEuNDIwNSA3LjE0MDQ3IDExLjQyMDUgNS4zOTA0NyAxMC4zNTA1IDQuMzIwNDdMOS43NjA0NyAzLjczMDQ3TDguNzAwNDcgNC44MDA0N0w5LjI5MDQ3IDUuMzkwNDdDOS43NzA0NyA1Ljg3MDQ3IDkuNzcwNDcgNi42NzA0NyA5LjI5MDQ3IDcuMTUwNDdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTYuMjkwNSAxMi4xNTA1TDE0LjcwMDUgMTMuNzQwNUwxNS43NjA1IDE0LjgwMDVMMTcuMzUwNSAxMy4yMTA1QzE3Ljg0MDUgMTIuNzIwNSAxOC42MzA1IDEyLjcyMDUgMTkuMTIwNSAxMy4yMTA1TDIwLjczMDUgMTQuODIwNUwyMS43OTA1IDEzLjc2MDVMMjAuMTgwNSAxMi4xNTA1QzE5LjEwMDUgMTEuMDgwNSAxNy4zNjA1IDExLjA4MDUgMTYuMjkwNSAxMi4xNTA1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0LjI5MDUgNi4xNTA0N0wxMC43MDA1IDkuNzQwNDdMMTEuNzYwNSAxMC44MDA1TDE1LjM1MDUgNy4yMTA0N0MxNi40MjA1IDYuMTQwNDcgMTYuNDIwNSA0LjM5MDQ3IDE1LjM1MDUgMy4zMjA0N0wxMy43NjA1IDEuNzMwNDdMMTIuNzAwNSAyLjc5MDQ3TDE0LjI5MDUgNC4zODA0N0MxNC43NzA1IDQuODcwNDcgMTQuNzcwNSA1LjY3MDQ3IDE0LjI5MDUgNi4xNTA0N1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Celebration = createIcon('Celebration', [
  [
    'path',
    { d: 'M1.23047 22.2705L15.2305 17.2705L6.23047 8.27047L1.23047 22.2705Z', key: 'oedkr7' },
  ],
  [
    'path',
    {
      d: 'M13.7605 12.8005L19.3505 7.21047C19.8405 6.72047 20.6305 6.72047 21.1205 7.21047L21.7105 7.80047L22.7705 6.74047L22.1805 6.15047C21.1105 5.08047 19.3605 5.08047 18.2905 6.15047L12.7005 11.7405L13.7605 12.8005Z',
      key: '15ji4d',
    },
  ],
  [
    'path',
    {
      d: 'M9.29047 7.15047L8.70047 7.74047L9.76047 8.80047L10.3505 8.21047C11.4205 7.14047 11.4205 5.39047 10.3505 4.32047L9.76047 3.73047L8.70047 4.80047L9.29047 5.39047C9.77047 5.87047 9.77047 6.67047 9.29047 7.15047Z',
      key: 'ws5lnj',
    },
  ],
  [
    'path',
    {
      d: 'M16.2905 12.1505L14.7005 13.7405L15.7605 14.8005L17.3505 13.2105C17.8405 12.7205 18.6305 12.7205 19.1205 13.2105L20.7305 14.8205L21.7905 13.7605L20.1805 12.1505C19.1005 11.0805 17.3605 11.0805 16.2905 12.1505Z',
      key: '1swzhh',
    },
  ],
  [
    'path',
    {
      d: 'M14.2905 6.15047L10.7005 9.74047L11.7605 10.8005L15.3505 7.21047C16.4205 6.14047 16.4205 4.39047 15.3505 3.32047L13.7605 1.73047L12.7005 2.79047L14.2905 4.38047C14.7705 4.87047 14.7705 5.67047 14.2905 6.15047Z',
      key: '1wbd0r',
    },
  ],
]);

export default Celebration;
